import React from 'react';
import './MediaUpload.scss';
import { ADMIN_ROLE } from '../../constants/global';
import {openWindow } from "../../utils/utils";
import { UPLOADMSG, MEDIASTATUS} from '../../constants/upload';


const ResultView = ({onFileLoad, fileName, fileSize, org_role, uploadStatus, onPublish, onReject, acceptTypes}) => {

  const ar = uploadStatus===MEDIASTATUS.APPROVED||uploadStatus===MEDIASTATUS.REJECTED?true:false;
return <>
{
  org_role!==ADMIN_ROLE?
  (
    <div className='uploadrow'>
      <div className='scanrow uploadcard'>
        <span className ="cb-icon cb-upload  cb-icon-14" style={{marginRight:'10px'}}></span>
        
        <div style={{display:'flex', flexDirection:'column', width:'80%'}}>
          <span className='uploadfileFont'> {fileName}</span>
          <span>{fileSize}</span>
        </div>
        <div style={{display:'flex', flexDirection:'column', alignItems: 'baseline'}}>
          <label htmlFor="inputFileView" id='labelView' style={{marginTop:'0px'}}>
            <a href='#' onClick={(e) => {e.preventDefault(); openWindow('https://professionals.collegeboard.org/pdf/bfcp-full-survey.pdf')}}>View</a>
          </label>

          <label htmlFor="inputFileUpload" id='labelUpload' style={{marginTop:'0px'}}>
            <div className='cb-link-default cb-link-blue'>Replace</div>
            <input type="file" accept={acceptTypes} id="inputFileUpload" name="fileF" onChange={e=>onFileLoad(e)} onClick={e=>{e.target.value = null}} /> 
          </label>
        </div>
      </div>
    </div>
    )
    :
    (     
      <div className='uploadrowadmin' style={{alignItems: 'baseline', display: 'flex'}}>
        <div className='scanrow uploadcard'>
          <span className ="cb-icon cb-upload  cb-icon-14" style={{marginRight:'10px'}}></span>
          
          <div style={{display:'flex', flexDirection:'column', width:'80%'}}>
            <span className='uploadfileFont'> {fileName}</span>
            <span>{fileSize}</span>
          </div>

          <div style={{display:'flex', flexDirection:'column', alignItems: 'baseline'}}>
            <label htmlFor="inputFileView" id='labelView' style={{marginTop:'0px'}}>
            <a href='#' onClick={(e) => {e.preventDefault(); openWindow('https://professionals.collegeboard.org/pdf/bfcp-full-survey.pdf')}}>View</a>
            </label>

            <label htmlFor="inputFileUpload" id='labelUpload' style={{marginTop:'0px'}}>
                <div className={ar?'':'cb-link-default cb-link-blue'}>Replace</div>
                <input type="file" accept=".jpg" id="inputFileUpload" name="fileF" 
                onChange={e=>onFileLoad(e.target.files)} 
                onClick={e=>{e.target.value = null}} 
                disabled={ar}/> 
            </label>
          </div>
        </div>
        <button type='button' className={`cb-btn cb-btn-primary`}  style={{marginLeft:'20px'}} onClick={onReject} disabled={ar}>Reject</button>
        <button type='button' className={`cb-btn cb-btn-primary`}  style={{marginLeft:'10px'}} onClick={onPublish} disabled={ar}>Accept</button>
      </div>
    )
}
</>;
};


export default ResultView;